import { camelCase, isArray, isObject, transform } from 'lodash';

import { getScheduleAggregationCompletion } from '@src/packages/dashboard/utils/getScheduleAggregationCompletion';

export const camelize = obj =>
  transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : camelCase(key);

    acc[camelKey] = isObject(value) ? camelize(value) : value;
  });

export const dateTypes = ['day', 'week', 'month', 'quarter', 'year'];

export const calculateScheduleProgress = schedule => getScheduleAggregationCompletion(schedule);
